import { ItineraryService } from './../itinerary.service';
import { ActivatedRoute } from "@angular/router";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Itinerary } from "./../itineray.model";
import { Component, OnInit } from "@angular/core";
import { v4 as uuid } from "uuid";

@Component({
  selector: "app-itinerary-reservations-ferries",
  templateUrl: "./itinerary-reservations-ferries.component.html",
  styleUrls: ["./itinerary-reservations-ferries.component.css"]
})
export class ItineraryReservationsFerriesComponent implements OnInit {
  constructor(private route: ActivatedRoute, private snackBar: MatSnackBar, public itineraryService: ItineraryService) { }

  itinerary: Itinerary;

  expanded: boolean[];

  ngOnInit() {
    this.itinerary = this.route.parent.parent.snapshot.data.itinerary;
    this.syncExpanded();
  }

  private syncExpanded(expandLast: boolean = false) {
    this.expanded = [];
    this.itinerary.reservations.ferries.forEach(() => this.expanded.push(false));
    if (expandLast) {
      this.expanded[this.expanded.length - 1] = true;
    }
  }

  removeFerry($event, ferry) {
    $event.stopPropagation();
    if (confirm("Vuoi veramente eliminare questa nave?")) {
      const idx = this.itinerary.reservations.ferries.indexOf(ferry);
      this.itinerary.reservations.ferries.splice(idx, 1);
      this.snackBar
        .open("Nave eliminata.", "Annulla", {
          duration: 4000
        })
        .onAction()
        .subscribe(() => {
          this.itinerary.reservations.ferries.splice(idx, 0, ferry);
          this.snackBar.open(
            "La nave che avevi eliminato è stata inserita nuovamente nella lista.",
            null,
            {
              duration: 4000
            }
          );
        });
      this.syncExpanded();
    }
  }

  addFerry() {
    this.itinerary.reservations.ferries.push({
      id: uuid(),
      notes: null,
      link: { longUrl: null, shortUrl: null },
      partner: null,
      price: null,
      routes: [
        {
          id: uuid(),
          title: "",
          company: "",
          code: "",
          from: "",
          fromDetail: "",
          fromCode: "",
          fromPlace: null,
          to: "",
          toDetail: "",
          toCode: "",
          toPlace: null,
          start: null,
          end: null,
          stops: null,
          duration: {
            hours: null,
            minutes: null
          }
        }
      ]
    });
    this.syncExpanded(true);
  }
}
